import React from "react";
import { Icon, Popup } from "semantic-ui-react";

import { useDispatch } from "react-redux";
import LogInvoiceChangeForm from "./LogInvoiceChangeForm";
import { useSearchParams } from "react-router-dom";
import invoiceActions from "actions/invoice";
import { CloseableContent } from "dyl-components";

const InvoiceActions = ({ invoice, account_id, onModify, isModifying }) => {
    const [params] = useSearchParams();
    const dispatch = useDispatch();
    return (
        <Popup 
            trigger={<Icon name='ellipsis horizontal' size='large' />}
            onOpen={() => {onModify(invoice.id)}}
            onClose={() => {onModify(null)}}
            position="bottom right"
            content={isModifying && (
                <CloseableContent onClose={() => {onModify(null)}}>
                    <LogInvoiceChangeForm account_id={account_id} paymentMethod={invoice.payment_type} status={invoice.invoice_status} invoice_id={invoice.id} refresh={() => {
                        dispatch(invoiceActions.read(account_id, {
                            page: params.get('page') || 1,
                            billed: params.get('billed')?.split(',') || undefined,
                            limit: 25,
                        }));
                        onModify(null);
                    }} />
                </CloseableContent>
            )}
            on={'click'}
            closeOnDocumentClick={false}
            open={isModifying}
        />
    );
};

export default InvoiceActions;
